var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDetach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    "data-name": "Group 231",
    transform: "translate(-1133.725 -1798)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 30,
    height: 30,
    rx: 5.294,
    transform: "translate(1133.725 1798)",
    fill: "#636b91",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_230",
    "data-name": "Group 230"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M1143.486,1818.838a.6.6,0,0,1-.424-1.023l10.478-10.478a.6.6,0,0,1,.848.848l-10.478,10.478A.6.6,0,0,1,1143.486,1818.838Z",
    fill: "#636b91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M1153.964,1818.838a.6.6,0,0,1-.424-.175l-10.478-10.478a.6.6,0,0,1,.848-.848l10.478,10.478a.6.6,0,0,1-.424,1.023Z",
    fill: "#636b91"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDetach);
export default __webpack_public_path__ + "static/media/icon-detach.12ac0535444024ceaadd18ae89f95a3d.svg";
export { ForwardRef as ReactComponent };